<div class="bg-white">
    <h2 class="settings-header px-4 py-3 mb-2 mb-md-5">
        {{'notification_time_settings' | translate}}
        <small>- {{'notification_time_settings_desc' | translate}}</small>
    </h2>
    
    <div class="settings-sub-header w-100 p-2">
        <h3 class="col-md-8 mx-auto px-md-4">
            <i class="far fa-clock"></i> {{ 'notifications' | translate}}
            <small>{{ 'notifications_time_settings_desc' | translate}}</small>
        </h3>
    </div>
    
    <div class="bg-grey pt-4">
        <div class="col-md-8 mx-auto px-md-4 p-0 px-2">
            <form class="form-horizontal form-box" [formGroup]="notificationTime">
                <h4 class="form-box-header">{{'notificationTime' | translate}}</h4>
                <div class="row px-2 px-sm-5 pt-3 g-0">
                    <label class="col-md-2 col-form-label" for="timeZone">{{'timeZone' | translate}}</label>
                    <div class="col-md-6 col-lg-5">
                        <tm-timezone-picker id="timeZone" formControlName="timeZone"></tm-timezone-picker>
                    </div>
                </div>
                <div class="row px-2 px-sm-5 py-3 g-0 d-flex align-items-center">
                    <label class="col-md-2 col-form-label pe-1" for="preferedTimeForEmails">{{'preferedTimeForEmails' | translate}}</label>
                    <div class="col-md-6 col-lg-5">
                        <tm-timepicker id="preferedTimeForEmails" formControlName="time"></tm-timepicker>
                    </div>
                </div>
            </form>
        </div>
    </div>
   
</div>